export default __webpack_public_path__ + "static/media/AnimalsRed_02.2422bac8.png";